module.exports = __webpack_public_path__ + "img/1527343216.8c1b0992.jpg";